import React from "react";

/*
Numbered tab bar. Hand-rolled rather than reusing components/Tabs/Tabs.js,
which wraps itself in a Bootstrap .card and keys on label strings.
*/
// Numbers come from position, so a tab in `hidden` doesn't leave a gap.
export const TABS = [
  { key: "product", label: "Product" },
  { key: "delivery", label: "Delivery" },
  { key: "service", label: "Service" },
  { key: "report", label: "Report" },
  { key: "note", label: "Notes" },
  { key: "activity", label: "Activity Log" },
];

const TabBar = function (props) {
  const { value, onChange } = props;
  const hidden = props.hidden || [];
  const tabs = TABS.filter(function (tab) {
    return !hidden.includes(tab.key);
  });

  return (
    <div className="tn-tabbar" role="tablist">
      {tabs.map(function (tab, index) {
        const active = tab.key === value;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={"tn-tab" + (active ? " tn-tab-active" : "")}
            onClick={function () {
              onChange(tab.key);
            }}
          >
            <span className={"tn-tab-num" + (active ? " tn-tab-num-active" : "")}>
              {index + 1}
            </span>
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default TabBar;
